// extracted by mini-css-extract-plugin
export default {"cameraContainer":"AccessWorkshopRollerDoor_cameraContainer__kkI4N","camera":"AccessWorkshopRollerDoor_camera__air7w"};